import { $post } from '@/api'

// 七牛图片地址
export const qiniuUploadUrl = 'https://up.qiniup.com' // 上传时的地址(华东区)
export const qiniuImageURLPrefix = 'https://img.senguo.cc/' // 访问图片时的域名
export const qiniuVideoURLPrefix = 'https://v.senguo.cc/' // 访问视频时的域名
export const getQiniuImgUrl = (path?: string, w: number = 100, h: number = 100) => {
    if (!path) return ''

    return path.startsWith('http') ? path : qiniuImageURLPrefix + path + '?imageView2/1/w/' + w + '/h/' + h
}

export const getVideoPreviewUrl = (path: string, w: number = 100) => {
    return qiniuVideoURLPrefix + path + `?vframe/jpg/offset/0/w/${w}`
}

export const getVideoUrl = (path: string) => {
    return qiniuVideoURLPrefix + path
}

export const getFullImageurl = (path?: string) => {
    return `${qiniuImageURLPrefix}${path}`
}

export const getQiniuUploadToken = (type: number) =>
    $post({
        url: '/goods/getqiniutoken',
        params: {
            bucket: type,
        },
    })
